import React from 'react';
import "./alertsAndNotifications.scss";

//Imagens:
import ImgalertsAndNotifications from "../../../../assets/realtimeData/alertsAndNotifications.png"
import { useTranslation } from 'react-i18next';

function AlertsAndNotifications() {
  const { t } = useTranslation()

  return (
    <div className='container-alerts'>
      <div className='img-alerts'>
        <img src={ImgalertsAndNotifications} alt="" srcset="" />
      </div>
      <div className='texts-alerts'>
        <h1>{t("realtime_data.notifications.title")}</h1>
        <p>{t("realtime_data.notifications.section_text_1")}</p>
        <p>{t("realtime_data.notifications.section_text_2")}</p>
      </div>
    </div>
  );
}

export default AlertsAndNotifications;